// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"723":"c8f817ba","744":"5668198e"}[chunkId] + ".chunk.js";
};